/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PianificazioneResDto } from '../../models/pianificazione-res-dto';

export interface PianificazioniControllerDeletePianificazione$Params {
  idPianificazione: number;
}

export function pianificazioniControllerDeletePianificazione(
  http: HttpClient,
  rootUrl: string,
  params: PianificazioniControllerDeletePianificazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PianificazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    pianificazioniControllerDeletePianificazione.PATH,
    'delete',
  );
  if (params) {
    rb.path('idPianificazione', params.idPianificazione, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PianificazioneResDto>;
      }),
    );
}

pianificazioniControllerDeletePianificazione.PATH =
  '/admin/pianificazioni/id/{idPianificazione}';
